import React, { Component } from 'react'
import { connect } from 'react-redux'

import { logged, notLoggedIn } from '../../store/actions/user'

import Helmet from 'react-helmet'
import Topbar from '../../SPRINTA/Topbar'
import Footer from '../../SPRINTA/Footer'
import T from '../../SPRINTA/translate/T'

class Template extends Component {

    constructor(props) {
        super(props)
        T.handleUpdate(() => {
            this.forceUpdate()
        })
    }

    handleLogin(response) {
        if(response.logged)
            this.props.logged(response.data)
        else
            this.props.notLoggedIn()
    }


    render() {
        return (
            <div>
                {!this.props.voucher && (
                    <Topbar
                        language={T.getLanguage()}
                        isLogged={this.props.userData ? true : false}
                        handleLogin={ response => this.handleLogin( response ) }
                        modalOpened={ null }
                        handleModalClose={ ((ref) => { }) }
                        />
                ) }

                <Helmet>
                    <title>SPRINTA | {this.props.voucher ? "Voucher" : "Checkout"}</title>
                    <meta property="og:locale" content="pt_BR"/>
                    <meta property="og:url" content={`www.sprinta.com.br`}/>
                    <meta property="og:title" content={`SPRINTA | Loucos por esportes`}/>
                </Helmet>

                { this.props.children }

                {console.log(this.props)}

                {/* {!this.props.voucher && (
                    <Footer
                        lang={T.getLanguage()}
                        handleLangChanged={lang => {
                            T.setLanguage(lang)
                        }}
                    />
                    
                )} */}
            </div>
        )
    }
}


const mapStateToProps = store => ({
    user: store.user
})

const mapDispatchToProps= {
    logged,
    notLoggedIn
}

export default connect( mapStateToProps, mapDispatchToProps )(Template)


// WEBPACK FOOTER //
// ./src/App/Template/index.js